<!--
  @Description 侧边栏菜单项组件
  @Date 2021-12-22
  @Author liushuo
-->
<template>
  <!-- 菜单项按钮 -->
  <div
    class="navItem"
    :class="[this.activeIndex === this.navIndex ? 'active' : '']"
    @click="changeNav"
  >
    <div class="icon">
      <img :src="item.icon" />
    </div>
    <div class="text">
      {{ item.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavItem',
  props: {
    item: {
      type: Object,
      default: () => { }
    },
    // 当前菜单项索引
    navIndex: {
      type: Number,
      default: -1
    },
    // 当前菜单组选中的索引
    activeIndex: {
      type: Number,
      default: -1
    }
  },
  methods: {
    changeNav () {
      this.$emit('change', this.item, this.navIndex)
    }
  }
}
</script>

<style lang="less" scoped>
@active-bg-color: #1050af;
@text-color: #dfeafb;
@nav-height: 62px;
@icon-height: 31px;

.navItem {
  width: 62px;
  height: 62px;
  margin: 7px 0;
  border-radius: 10px;
  transition: 0.3s;
}

.navItem:hover {
  transition: 0.3s;
  cursor: pointer;
  background-color: @active-bg-color;
}

.icon {
  width: 100%;
  height: 31px;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  > img {
    height: 22px;
    width: 22px;
  }
}

.text {
  width: 100%;
  height: calc(@nav-height - @icon-height);
  font-size: 12px;
  color: @text-color;
  display: flex;
  align-items: center;
  justify-content: center;
}

.active {
  background-color: @active-bg-color;
}
</style>
